import { TValidatorResponse } from './types/validator-response.types';

export const isNumber = (value: string): TValidatorResponse =>
  isNaN(Number(value)) ? 'Must be a number' : undefined;
